import { tagItem } from '@/types/system/tag.type'

/**
 *
 */
export default function indexPathByName(name: string, tagTree: tagItem[]) {
  let path: number[] = []
  const tagTreeString: string = JSON.stringify(tagTree)
  // 如果当前 name 并不存在于 tree 中，直接返回空路径
  if (tagTreeString.indexOf(`"${name}"`) === -1) return path

  function findPathbyName(tree: tagItem[], name: string, path?: number[]): undefined | number[] {
    for (let i = 0; i < tree.length; i++) {
      const tempPath = path || []
      tempPath.push(tree[i].id)
      if (tree[i].name === name) {
        return tempPath
      }
      if (tree[i].sub_tags) {
        const reuslt = findPathbyName(tree[i].sub_tags!, name, tempPath)
        if (reuslt) {
          return reuslt
        }
      }
    }
  }
  path = findPathbyName(tagTree, name) || []
  return path
}
